import React, { useEffect, useState } from "react";

import swal from "sweetalert";
import { LoadingSpinner } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../helper/Components";
import { ApiUnit } from "../unit/ApiUnit";
import SearchAhbab from "./SearchAhbab";
import ApiHabibProgress from "../config/habibprogress/ApiHabibProgress";
import HabibProgressBoard from "./HabibProgressBoard";

const AhbabProgressBoard = () => {
  const [loading, setLoading] = useState(false);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const [ahbabBoard, setAhbabBoard] = useState([]);
  //useState(false);
  const [unit, setUnit] = useState({
    unitId: loggedInUnitId,
    unitName: "",
    unitTypeName: unitTypeName,
  });
  const [searchButton, setSearchButton] = useState(false);
  const [searchAhbabModel, setSearchAhbabModel] = useState({
    unitId: loggedInUnitId,
    loggedInUnitId: loggedInUnitId,
    activePage: 1,
    isSubUnits: true,
    sortModel: {},
  });

  useEffect(() => {
    if (unit.unitId === 0) {
      ApiUnit()
        .getUnit(loggedInUnitId, loggedInUnitId)
        .then((res) => {
          let temp = res.data.unitList[0];
          setSearchAhbabModel({
            unitId: temp.id,
            activePage: 1,
          });
          setUnit({ unitId: temp.id, unitName: temp.name });
        })
        .catch((err) => console.log(err));
    }
  }, [unit.unitId, loggedInUnitId]);

  useEffect(() => {
    setLoading(true);

    if (searchButton) {
      ApiHabibProgress()
        .GetAhbabProgressForBoard(searchAhbabModel)
        .then((res) => {
          setAhbabBoard(res.data);
          //setAhbab(res.data.list);
          setLoading(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [searchAhbabModel, searchButton]);
  const fetchAhbabBoard = () => {
    ApiHabibProgress()
      .GetAhbabProgressForBoard(searchAhbabModel)
      .then((res) => {
        setAhbabBoard(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch updated board data", err);
      });
  };
  return (
    <div>
      <div className="wrapper wrapper-custom wrapper-content animated fadeInRight">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="ahbab_search" />}</h5>
          </div>
          <div className="ibox-content">
            <SearchAhbab
              unitId={unit.unitId}
              setUnit={setUnit}
              searchAhbabModel={searchAhbabModel}
              setSearchAhbabModel={setSearchAhbabModel}
              setSearchButton={setSearchButton}
            />
          </div>
        </div>
        {searchButton && (
          <div className="ibox ">
            <div className="ibox-title">
              <h5>{<GetLanguageString props="ahbab_details" />}</h5>
            </div>
            <div className="ibox-content" style={{ overflowX: "visible" }}>
              {!loading ? (
                ahbabBoard.length !== 0 ? (
                  <HabibProgressBoard
                    boardData={ahbabBoard}
                    refreshBoard={fetchAhbabBoard}
                    searchAhbabModel={searchAhbabModel}
                  />
                ) : (
                  <NoResult />
                )
              ) : (
                LoadingSpinner()
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AhbabProgressBoard;
